import React from "react";
import Collapsible from "react-collapsible";
import "../../styles/uploadimage.css";
import "../../styles/static-content.css";
import ReactGA from "react-ga";


export default class TermsConditions extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        ReactGA.pageview('/Accept terms of use');
    }

    render() {

        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    TERMS AND CONDITIONS
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>

                            <div className="col-sm-6 UploadPaintingCard no-margin padding-35 ConfirmBuyRequest">


                                <div className="col-md-12">


                                    <p className="static-text-inside mb-5">
                                    YourMasterpieces PTE. LTD. ("YourMasterpieces", together with "we", "us", and "our") provides a service (“Service(s)”) for
                                        selling and purchasing original works of art and commercially exploiting digital
                                        images of the works of art through our mobile app (“App(s)”) accessible on the
                                        Google Play and iOS, or website (“Site”), accessible at <a
                                        href="https://www.yourmasterpieces.com"
                                        className="link">www.yourmasterpieces.com</a> to users (“user(s)”, “you”,
                                        “your”) of the Services.
                                        <br/>
                                        Please read carefully the following Terms and Conditions and our <a
                                       href="/privacy-and-data-policy"
                                        className="link">Privacy and Data Policy</a> .
                                        These Terms and Conditions govern your access to and use of the Site and
                                        Services and constitute a binding legal agreement between you and
                                        "YourMasterpieces". You acknowledge and agree that, by accessing or using the
                                        Site or Services, or by selling or purchasing a work on or through the Site or
                                        Services, or by posting any content on the Site, you are indicating that you
                                        have read, understood and agreed to be bound by these terms, whether or not you
                                        have registered with the Site.

                                        <br/>
                                        If you do not agree to these terms, you do not have the right to access or use
                                        the Site or Services.
                                        If you access “YourMasterpieces” Apps or Site on behalf of a company or any
                                        other legal entity, your access implies that you:<br/>
                                        (a) agree to these Terms and Conditions,<br/>
                                        (b) represent the said company or other legal entity,<br/>
                                        (c) are at least 18 years of age, or of the age of majority in the company’s
                                        jurisdiction, and <br/>
                                        (d) warrant that you have the authority to bind that company or other legal
                                        entity to these Terms and Conditions <br/>
                                        In such an event, “you” and “your” will refer and apply to the said company or
                                        other legal entity.

                                    </p>


                                    <Collapsible trigger="1. Eligibility">
                                        <p className="static-text-inside">
                                            You may use our Services only if you can form a binding contract with us,
                                            and only as permitted by law. You are not allowed to use our Services if you
                                            are a person under the age of thirteen (13). Minors under the age of
                                            majority in their jurisdiction and above the age of 13 require the consent
                                            of a legal guardian for use of the Site and Services. Additional eligibility
                                            requirements may apply to some Services, and the user will be notified of
                                            those requirements in these Terms and Conditions or otherwise in connection with those
                                            Services.

                                            <br/>
                                            YourMasterpieces reserves the right to block the profile of any user found
                                            to be falsifying any information provided to YourMasterpieces which conceals
                                            the user’s ineligibility from using the Site and Services. YourMasterpieces
                                            also reserves the right to unblock the user after the information has been
                                            corrected, provided it has not resulted in a breach of contract.
                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="2. Modification of Terms and Conditions">
                                        <p className="static-text-inside">
                                            YourMasterpieces reserves the right to modify, discontinue or terminate the
                                            Site or Services, or to modify these Terms and Conditions, at any time, and
                                            without prior notice, at its sole discretion. At any modification to these
                                            Terms and Conditions after the first login of the user, s/he will be
                                            prompted to accept these modified Terms and Conditions. If the user fails to
                                            accept the modified Terms, the user may not access the Site, or any Service
                                            provided through the Site. It is also necessary that you keep a check on
                                            such changes from time to time and keep yourself apprised of any changes.
                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="3. Submitting a Listing for Sale">
                                        <p className="static-text-inside">

                                            <ol>
                                                <li>As a Member, you may submit listings for original works of art that
                                                    you
                                                    have created and that you desire to sell through the Site and
                                                    Services.
                                                    You may not submit listings marked as “created by me” for works of
                                                    art
                                                    that were created by another artist. In the case of an artist
                                                    reporting
                                                    the artwork as their work of art, the artwork will be temporarily
                                                    blocked from your profile page pending a review. YourMasterpieces
                                                    may
                                                    demand a proof of possession of the artwork in this situation. By
                                                    posting a work of art on the Site and by listing it “for sale”, you
                                                    confirm that you are the sole creator of that work of art, or that
                                                    you
                                                    are the sole owner of that work of art with all its rights belonging
                                                    solely to you.
                                                </li>
                                                <li> As a Member you may also submit listings for digital images of
                                                    non-digital works of art that you have created and own the copyright
                                                    of
                                                    and that you desire to commercially exploit through the Site and
                                                    Services.
                                                </li>
                                                <li> YourMasterpieces requires you as a seller to ensure that any
                                                    artwork
                                                    submitted on the Site is either a non-digital artwork, or digital
                                                    images
                                                    of a non-digital artwork . In the event an artwork cannot be
                                                    identified as a non-digital work of art, YourMasterpieces reserves
                                                    the
                                                    right to remove a listing and send a notification to the user about
                                                    the
                                                    deletion, if it is deemed inconsistent with these guidelines.
                                                    YourMasterpieces also reserves the right to ask for additional proof
                                                    of
                                                    an art being a non-digital peice of art.
                                                </li>
                                                <li> YourMasterpieces reserves the right to edit any listings to ensure
                                                    that they comply with these guidelines. YourMasterpieces reserves
                                                    the
                                                    right to demand from you the necessary declarations and/or documents
                                                    to
                                                    prove this compliance.
                                                </li>
                                                <li> You acknowledge that your listings after uploading may not be
                                                    immediately searchable by keyword or category for several hours (or
                                                    up
                                                    to 24 hours, or more in some circumstances).
                                                </li>
                                                <li> In the scenario of an artwork being sold, YourMasterpieces
                                                    reserves
                                                    the right to prevent the user from deleting the artwork until the
                                                    delivery has been completed. In the interim period of the purchase
                                                    and
                                                    delivery, a tag of “SOLD” will be displayed on the artwork. The
                                                    seller
                                                    is bound to honor the commitment to sell once the seller accepts to
                                                    sell, either on the app or the site.
                                                </li>
                                                <li>  In the event of an artwork not being dispatched by the seller of
                                                    the
                                                    art within 1 week of the time an order is received, YourMasterpieces
                                                    reserves the right to block access to view the user profile of the
                                                    seller, pending a confirmation of dispatch of the artwork. Once the
                                                    confirmation is received, YourMasterpieces reserves the right to
                                                    unblock
                                                    the user profile of the seller.
                                                </li>

                                            </ol>

                                        </p>

                                    </Collapsible>


                                    <Collapsible trigger="4. Submitting an Artwork for Special Requests">
                                        <p className="static-text-inside">

                                            <ol>
                                                <li> Users can submit special requests (henceforth such users are
                                                    referred
                                                    to as the “Requestor(s)”) for customized artworks through the Site
                                                    and
                                                    Apps. This will be done via a special portal and can include the
                                                    request
                                                    for a particular artist of interest. Artists will submit their
                                                    quotations for the requesters to accept. The requestors can select
                                                    the
                                                    artists based on their style, price and liking. Once the request for
                                                    customization is accepted on both ends, a binding contract will be
                                                    signed.
                                                </li>
                                                <li> The contract for special requests will be managed by
                                                    YourMasterpieces
                                                    as the broker to ensure compliance on both ends of the transaction.
                                                    A
                                                    contract will thus exist between the Requestor and YourMasterpieces,
                                                    and
                                                    the Artist and YourMasterpieces.
                                                </li>
                                                <li>  Once the requestor signs the contract, an advance payment will be
                                                    requested on behalf of the artist. This payment will be held by
                                                    YourMasterpieces and cleared when the artist delivers the artwork as
                                                    requested by the Requestor. The Requestor will have 48 hours after
                                                    the
                                                    delivery of the artwork to report any damage.
                                                </li>
                                                <li> The submission of special requests may include but are not limited
                                                    to
                                                    special themed artworks, murals, customization of existing artworks
                                                    by
                                                    artists, and requests tailored to fit a certain space.
                                                </li>
                                            </ol>

                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="5. Buying an Artwork- Payment, Transportation and Taxes">
                                        <p className="static-text-inside">
                                            <ol>
                                                <li> Artworks that are listed “for sale” by the artist can be purchased
                                                    by
                                                    any individual or legal entity by expressing the intent to buy
                                                    through
                                                    the “request to buy” button and following the guidelines for making
                                                    the
                                                    requisite payments to the indicated bank account.
                                                </li>
                                                <li> Once the intent to buy is received, a proforma of the invoice
                                                    will be
                                                    sent to the buyer including all the charges like taxes,
                                                    transportation,
                                                    and insurance etc.
                                                </li>
                                                <li> Once the payment is received in the YourMasterpieces bank
                                                    account, the
                                                    buyer will be notified of the receipt of payment, the time frame
                                                    and
                                                    mode of the dispatch procedures, and estimated date of delivery.
                                                </li>
                                                <li> The Buyer will be responsible for the payment of any
                                                    government duties
                                                    and taxes applicable on such artwork at the place of delivery.
                                                </li>
                                                <li> As and where applicable, such government duties and taxes can
                                                    be
                                                    estimated in advance, and added to the price of the artwork, and
                                                    paid in
                                                    advance. However, in case of any difference payable at the place
                                                    of
                                                    delivery, such payments will be the responsibility of the buyer.
                                                </li>
                                                <li> Transport Insurance will be billed to the account of the
                                                    buyer. This
                                                    can be arranged by the seller if required with charges billed to
                                                    the
                                                    buyer, or it can be arranged and paid by the buyer with clear
                                                    instructions in that regard.
                                                </li>
                                                <li> As much as possible, the artwork will be dispatched to the
                                                    indicated
                                                    address of the buyer through a courier company. In case a
                                                    different
                                                    transportation method is used, buyer’s consent will be taken in
                                                    advance.
                                                </li>
                                                <li> The artwork will be packed appropriately to ensure safe
                                                    transportation. The responsibility of packaging lies with the
                                                    artist.
                                                    YourMasterpieces waives the responsibility for damaged artworks
                                                    that
                                                    result from improper packaging, or from the artist not following
                                                    packaging methods approved by YourMasterpieces.
                                                </li>
                                            </ol>
                                        </p>

                                    </Collapsible>


                                    <Collapsible trigger="6. Intellectual Property Rights and Data Ownership">
                                        <p className="static-text-inside">
                                            <ol>
                                                <li> Use of Services shall, at all times, be governed by and subject to
                                                    the
                                                    applicable laws regarding copyright, trademark, patent, and trade
                                                    secret
                                                    ownership and use of intellectual property and users agree to abide
                                                    by
                                                    such laws. A user shall be solely responsible for any violation of
                                                    any
                                                    law, including any infringement of any intellectual property rights
                                                    caused by said user’s use of Services.
                                                </li>
                                                <li> A user shall be solely responsible for reporting to
                                                    YourMasterpieces
                                                    any instances of any infringements of any intellectual property
                                                    rights
                                                    against the said user by another user of the Services.
                                                </li>
                                                <li>
                                                    YourMasterpieces waives the
                                                    responsibility from any liability resulting from any violation of
                                                    any
                                                    laws or
                                                    any infringement of intellectual property rights by a user on its
                                                    Services.
                                                </li>
                                                <li> When a user uploads, submits, stores or sends any content to or
                                                    through the Services, the user gives YourMasterpieces including,
                                                    YourMasterpieces’ employees, agents, consultants, as the case may
                                                    be, a
                                                    worldwide license to use, copy, transmit, host, store, reproduce,
                                                    modify, create derivative works of, communicate, publish, publicly
                                                    perform, publicly display, print, edit, translate, reformat and
                                                    distribute such content. The rights users grant in this license are
                                                    for
                                                    the limited purpose of operating, promoting, and improving the
                                                    Services,
                                                    and to develop new services. This license shall continue to operate
                                                    even
                                                    if a user stops using the Services. The user shall not hold
                                                    YourMasterpieces accountable for the above in any court of law.
                                                    YourMasterpieces will declare the artwork’s intellectual property
                                                    rights
                                                    to belong to the user alone.
                                                </li>

                                            </ol>
                                        </p>

                                    </Collapsible>


                                    <Collapsible trigger="7. Settlement of Disputes and Governing Law">
                                        <p className="static-text-inside">
                                            <ol>


                                                <li>
                                                     The Services may be provided, and the Site may be controlled, and
                                                    operated from and through any country, and may be subject to the
                                                    laws of
                                                    that country. When a user accesses the Services from any location,
                                                    then
                                                    the user is responsible for compliance with the local laws
                                                    applicable to
                                                    such user. YourMasterpieces will not be held accountable for the
                                                    user’s
                                                    use of the Site and Services that is inconsistent with the local
                                                    governing law.
                                                </li>
                                                <li>
                                                     This Agreement shall be governed by and shall be construed in
                                                    accordance with the laws of India. All disputes relating to this
                                                    Agreement shall be settled in the courts located in Mumbai, India.
                                                    The
                                                    courts in Mumbai, India shall have the sole jurisdiction in any such
                                                    disputes.

                                                </li>
                                            </ol>
                                        </p>

                                    </Collapsible>


                                    <Collapsible trigger="8. Disclaimer">
                                        <p className="static-text-inside">
                                            <ol>


                                                <li>
                                                     YourMasterpieces is an online platform for sharing, buying and
                                                    selling of original works of non-digital art and their digitized
                                                    forms by any individual, and does not in any way support or
                                                    encourage distribution of any content that is offensive or in
                                                    violation of any laws.
                                                </li>
                                                <li>

                                                     YourMasterpieces shall not be responsible for viruses, worms,
                                                    trojan
                                                    horses, and other harmful or destructive content that may have been
                                                    uploaded to the Apps or the Site. The Site may contain content that
                                                    is
                                                    offensive, indecent, or otherwise objectionable. The Site may also
                                                    contain content that infringes the intellectual property and other
                                                    proprietary rights of third parties, or the downloading, copying or
                                                    use
                                                    of which is subject to certain additional Terms and Conditions,
                                                    stated
                                                    or unstated. YourMasterpieces disclaims any responsibility from any
                                                    harm
                                                    resulting from the use of the Site, or from any downloading of
                                                    content
                                                    posted on the Site. All responsibility of any content in violation
                                                    of
                                                    any legal or moral codes of any individual or entity lies solely
                                                    with
                                                    the individual or the entity posting such content. YourMasterpieces
                                                    will
                                                    try it’s best to filter such content as much as possible, on its own
                                                    detection or on intimation of any such violation by an individual or
                                                    entity.
                                                </li>
                                                <li>
                                                     In the event that a posting or listing on its Site or Apps is
                                                    found to
                                                    be in violation of any such laws, or is found to be in violation of
                                                    any
                                                    religious, political or cultural codes and sensibilities of any
                                                    person
                                                    or community, and on being informed of any such violation,
                                                    YourMasterpieces reserves the right to immediately remove such
                                                    offensive
                                                    content from all its services immediately without assigning any
                                                    explanation or intimation to the member posting it. The person
                                                    posting
                                                    such matter will be solely responsible for all liabilities, legal or
                                                    otherwise, arising from any such postings.
                                                </li>
                                                <br/>
                                                Please read carefully the following Terms and Conditions for users on the platform
                                                as
                                                they govern your access to and use of the Site and its Services.

                                            </ol>
                                        </p>

                                    </Collapsible>


                                </div>


                            </div>
                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/static/terms-and-conditions.js